import React from 'react'
import { Link } from 'react-router-dom'
import { usePageCrumbs } from '@/component/layout/TopNav/usePageCrumbs.ts'
import { ChevronRightIcon } from '@/component/layout/ShellIcons.tsx'

const Breadcrumb: React.FC = () => {
    const crumbs = usePageCrumbs()

    return (
        <nav className={'top-nav__breadcrumb'} aria-label={'Breadcrumb'}>
            <ol>
                {crumbs.map((crumb, index) => (
                    <li key={crumb.label}>
                        {index > 0 && <ChevronRightIcon className={'top-nav__breadcrumb-separator'} />}
                        {crumb.href ?
                            <Link to={crumb.href}>{crumb.label}</Link> :
                            <span aria-current={'page'}>{crumb.label}</span>
                        }
                    </li>
                ))}
            </ol>
        </nav>
    )
}

export default Breadcrumb
